import { Address } from '@/dataV3/Common/Address'
import { MemberOptions } from '@/dataV3/User/MemberOptions'
import { User } from '@/dataV3/User/User'
import { APIRoute } from '@/modules/utils'
import { PureObject } from 'emt-library'

export type PetOwnerBody = {
  insurance: string
  insuranceAffiliationDatas: {
    // TODO
    identifier: string
  }
  santevet: boolean
}

export type BorrowerStep2Body = {
  address: PureObject<Address>
  phone: string
  mainPicture: string | null
  pictures: string[]
}

export type BorrowerStep3Body = {
  description: string
}

export type BorrowerStep4Body = {
  memberOptions?: Partial<PureObject<MemberOptions>>
  optins?: string[]
}

export type BorrowerStep5Body = {
  profiles: string[]
}

export type BorrowerStep6Body = {
  insurance: string
  insuranceAffiliationDatas: {
    // TODO
    identifier: string
  }
}

export type BorrowerBody =
  | BorrowerStep2Body
  | BorrowerStep3Body
  | BorrowerStep4Body
  | BorrowerStep5Body
  | BorrowerStep6Body

export type Body =
  | {
      type: 'petowner'
      body: PetOwnerBody
    }
  | {
      type: 'borrower'
      body: BorrowerBody
    }

export type Response = User

export const PetOwnerRoute: APIRoute = {
  method: 'PUT',
  path: '/acquisition/members/petowners',
}

export const BorrowerRoute: APIRoute = {
  method: 'PUT',
  path: '/acquisition/members/borrower',
}
